import { useKioskTheme } from '../../context/KioskTheme/kioskTheme';
import { isElectron } from '../../helpers/EnvironmentFlags/EnvironmentFlags';
import { ImageHelper } from '../ImageHelper/ImageHelper';
import { useLocalization } from '../../context/Localization/localization';
import css from './ThemeImage.module.scss';
import classNames from 'classnames';
import { useKioskState } from '../../context/Kiosk/kiosk';
import { ThemeImageProps } from './ThemeImage.types';
import { KioskTheme } from '../../css/themes/kioskthemes';

export const ThemeImage = ({ themeImageType }: ThemeImageProps) => {
    const theme: KioskTheme = useKioskTheme();
    const Localization = useLocalization();
    const {
        dealer: { name: dealerName, theme: themeName },
    } = useKioskState();
    const isKiosk: boolean = isElectron();
    let imageSrc: string = '';
    let altText: string | null = null;

    switch (themeImageType) {
        case 'internalBackground':
            imageSrc = isKiosk ? theme.internalBackgroundKiosk : '';
            break;
        case 'landingPageBanner':
            imageSrc = isKiosk ? theme.landingPageBannerKiosk : theme.landingPageBannerMobile;
            altText = Localization.formatString(Localization.BannerImage, dealerName) as string;
            break;
        case 'landingPageBackground':
            imageSrc = isKiosk ? theme.landingPageBackgroundKiosk : '';
            break;
        case 'internalBanner':
            imageSrc = isKiosk ? '' : theme.internalBannerMobile;
            altText = Localization.formatString(Localization.BannerImage, dealerName) as string;
            break;
        case 'logo':
            imageSrc = isKiosk ? theme.kioskLogo : theme.mobileLogo;
            altText = Localization.formatString(Localization.Logo, themeName) as string;
            break;
        case 'kioskHeaderLogo':
            imageSrc = theme.kioskHeaderLogo ?? theme.kioskLogo;
            break;
        case 'mobileHeaderLogo':
            imageSrc = theme.mobileHeaderLogo ?? theme.mobileLogo;
            break;
    }

    const isSvg: boolean = (/\.svg$/i).test(imageSrc?.trim());

    return imageSrc ? (
        <div
            className={classNames(
                isSvg && themeImageType === 'logo' && !isKiosk && css.svgMobileLogoWrapper,
            )}
        >
            <ImageHelper
                imageProps={{
                    src: imageSrc,
                    alt: altText ?? Localization.LogoPlain,
                }}
                className={classNames(
                    css.themeImage,
                    themeImageType === 'landingPageBackground' && css.accessibilityHidden,
                    isSvg && themeImageType === 'logo' && isKiosk && css.svgLogo,
                    isSvg && themeImageType === 'kioskHeaderLogo' && css.svgHeaderLogo,
                    isSvg && themeImageType === 'mobileHeaderLogo' && css.svgMobileHeaderLogo,
                )}
            />
        </div>
    ) : null;
};
ThemeImage.displayName = 'ThemeImage';